import Button from 'components/shared/Button';
import { DraftObservation, ObservationSubject } from 'interfaces/observation';
import { useForm } from 'react-hook-form';

interface Props {
  subject: ObservationSubject;
  subjectLabel?: string;
  disableSubmit?: boolean;
  handleSubmit: (ob: DraftObservation) => void;
}

const ObservationForm: React.FC<Props> = ({
  subject,
  subjectLabel,
  disableSubmit,
  handleSubmit,
}) => {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = ({ description }) => {
    handleSubmit({
      description,
      subject,
      source: 'user',
      status: 'unknown',
    });
    reset();
  };

  return (
    <form onSubmit={handleFormSubmit(onSubmit)}>
      <div className="w-full py-6 pl-3">
        <h3 className="text-sm font-medium leading-5 text-gray-900 truncate">
          {`New ${subjectLabel || subject}`}
        </h3>
        <div className="flex items-center justify-between">
          <div className="flex-1 truncate">
            <div className="mt-2 max-w-xl pr-5 rounded-md shadow-sm">
              <input
                id="name"
                className="block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                autoComplete="off"
                {...register('description', {
                  required: 'Please enter a description',
                })}
              />
            </div>
          </div>
          <div className="mt-2">
            {/* TODO(bobsin): add loading */}
            <Button type="submit" disabled={!!disableSubmit} title="Submit" />
          </div>
        </div>
        {errors?.description && (
          <div className="mt-2 text-xs text-red-600">
            {errors?.description.message}
          </div>
        )}
      </div>
    </form>
  );
};

export default ObservationForm;
